module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container push-top"
  }, [(_vm.contacts === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.contacts !== false && _vm.contacts.length <= 0) ? _c('div', {
    staticClass: "no-contacts"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('contacts.no_contacts_msg_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('contacts.no_contacts_msg_body')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.Events.$emit('modalOpen', 'newContactModal')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contacts.add_contact')))])]), _vm._v(" "), (_vm.contacts !== false && !_vm.showArchivedContacts && _vm.archivedContacts.length > 0) ? _c('button', {
    staticClass: "button is-primary is-medium view-archived-contacts",
    on: {
      "click": function($event) {
        _vm.showArchivedContacts = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.view_archived_contacts')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contacts !== false && _vm.contacts.length > 0) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "searchbox is-pulled-right"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": _vm.$t('search.placeholder')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('navigation.contacts')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [(_vm.contacts !== false && _vm.contacts.length > 0) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        _vm.changeSort('name')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.table.name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.changeSort('email')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.table.email')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.changeSort('company')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.table.company')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.filteredContacts.length > 0) ? _c('tbody', _vm._l((_vm.filteredContacts), function(contact) {
    return _c('tr', {
      key: contact.id
    }, [_c('td', [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + contact.email
      }
    }, [_vm._v(_vm._s(contact.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contact.company))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "contact-options"
    }, [_c('a', {
      attrs: {
        "title": "Edit Contact"
      },
      on: {
        "click": function($event) {
          _vm.Events.$emit('modalOpen', 'editContactModal', {
            contact: Object.assign({}, contact)
          })
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-edit"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "title": "Send New Document"
      },
      on: {
        "click": function($event) {
          _vm.Events.$emit('modalOpen', 'newDocumentModal', {
            contact: Object.assign({}, contact)
          })
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-doc-new"
    })])])])])
  })) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "empty-search",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.table.empty_search')))])])])])]) : _vm._e()]), _vm._v(" "), ((_vm.contacts === false ||
    _vm.contacts.length > 0) && !_vm.showArchivedContacts && _vm.archivedContacts.length > 0) ? _c('button', {
    staticClass: "button is-primary is-medium view-archived-contacts",
    on: {
      "click": function($event) {
        _vm.showArchivedContacts = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.view_archived_contacts')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [(_vm.showArchivedContacts && _vm.archivedContacts.length > 0) ? _c('h2', {
    staticClass: "is-pulled-left archived-contacts"
  }, [_vm._v(_vm._s(_vm.$t('contacts.archived_contacts')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [(_vm.showArchivedContacts && _vm.archivedContacts.length > 0) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('contacts.table.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contacts.table.email')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contacts.table.company')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.archivedContacts), function(contact) {
    return _c('tr', {
      key: contact.id
    }, [_c('td', [_vm._v(_vm._s(contact.name))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + contact.email
      }
    }, [_vm._v(_vm._s(contact.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contact.company))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "contact-options"
    }, [_c('a', {
      attrs: {
        "title": "Edit Contact"
      },
      on: {
        "click": function($event) {
          _vm.Events.$emit('modalOpen', 'editContactModal', {
            contact: Object.assign({}, contact)
          })
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-edit"
    })])])])])
  }))])]) : _vm._e()])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "icon icon-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a932ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Contacts.vue
// module id = 545
// module chunks = 0